import { gql } from '@apollo/client';
import type { Segment } from '@fixter/i18n';
import { declareGQL } from '$apollo/util';
import type { CmsFilter, CmsProductItem } from '$cms/types';

export interface QueryFetchProductCollectionData {
  readonly getCmsProducts: CmsProductItem[];
}

export interface QueryFetchProductCollectionDataVariables {
  readonly filter: CmsFilter;
  readonly segment: Segment;
  readonly limit: number;
  readonly preview?: boolean;
}

export const QUERY_FETCH_PRODUCT_COLLECTION_DATA = declareGQL<CmsProductItem[]>(gql`
  query FetchProductCollectionData(
    $filter: CmsFilterInput!
    $segment: String!
    $preview: Boolean
    $limit: Int
  ) {
    getCmsProducts(filter: $filter, segment: $segment, preview: $preview, limit: $limit) {
      id
      name
      sku
      slug
      image
      popularity
      shortDescription
      description
      shortSymptoms
      symptoms
      shortFrequency
      frequency
      shortItemsReplaced
      itemsReplaced
    }
  }
`);
